import styled from "styled-components";

interface FrameProps {
  frame: {
    src: string;
    description: string;
    url: string;
    isExternalLink: boolean
  }
}

export function Frame({ frame }: FrameProps) {
  return (
    <LinkUI href={frame.url} target={frame.isExternalLink? '_blank' : '_self'}>
      <FrameItem>
        <FrameImage src={frame.src} />
        { frame.description? (
          <Description>{frame.description}</Description>
        ): ('')}
      </FrameItem>
    </LinkUI>
  );
}

const FrameItem = styled.li`
  display: flex;
  position: relative;
`;

const FrameImage = styled.img`
  width: 100%;
  height: auto;
`;

const Description = styled.p`
  position: absolute;
  left: 0;
  bottom: 60px;
  background-color: #fff;
  max-width: 260px;
  font-family: 'Coolvetica Condensed', Arial, Helvetica, sans-serif;
  font-size: 40px;
  padding: 8px;
  line-height: 1.1;
`;

const LinkUI = styled.a`
  color: blue;
  text-decoration: none;
`;
